import { Box } from "@chakra-ui/react"
import React from "react"

import { Footer } from "../components/ui/Footer"

type BaseLayoutProps = {
  children: React.ReactNode // 👈️ type children
}

export const BaseLayout: React.FunctionComponent<BaseLayoutProps> = (props: BaseLayoutProps) => {
  return (
    <Box minW="320" background="page.background">
      {props.children}
      <Footer />
    </Box>
  )
}
